import React, { useState } from 'react'
import styles from './index.module.scss'
import UbfLogo from '../../assets/ubf-logo-int-blue.svg'
import { useNavigate } from 'react-router'
import { routes } from '../../../../utils/routes'
import PrimaryButton from '../button'
import { handleRegistrationScroll } from '../../../../utils/helper'

const Nav = () => {
    const navigate = useNavigate()
    const[menuOpen, setMenuOpen] = useState(false);
    const showMenu = () => {
        setMenuOpen(!menuOpen)
    }

    const handleLinkClick = () => {
        setMenuOpen(false)
    }

    const MENU_ITEMS = [
        {
            title: 'Overview',
            section: 'overview'
        },
        {
            title: 'Registration',
            section: 'registration'
        },
        {
            title: 'Resources',
            section: 'resources'
        },
        {
            title: 'Schedule',
            section: 'schedule'
        },
        {
            title: 'Contact',
            section: 'contact'
        }
    ]

    return (
        <nav>
            <div className={`${menuOpen ? styles.menu_container+ ' ' + styles.active : styles.menu_container}`}>
                <ul onClick={handleLinkClick}>
                    {MENU_ITEMS.map((item, index) => (
                        <li key={index}>
                            <a href={`#${item.section}`}>{item.title}</a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={styles.nav_container}>
                <div className={styles.nav_logo}onClick={() => navigate(routes.HOME)}>
                    <img src={UbfLogo} alt="ubf logo"/>
                </div>
                <ul className={styles.nav_menu}>
                    {MENU_ITEMS.map((item, index) => (
                        <li key={index}>
                            <a href={`#${item.section}`}>{item.title}</a>
                        </li>
                    ))}
                </ul>
                <PrimaryButton onClick={handleRegistrationScroll} className={styles.register_button}>
                    Register here
                </PrimaryButton>
                <div className={`${menuOpen ? styles.hamburger_menu+ ' ' + styles.toggle : styles.hamburger_menu}`} onClick={showMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </nav>
    )
}

export default Nav